import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-msg',
  templateUrl: './confirm-msg.component.html',
  styleUrls: ['./confirm-msg.component.scss']
})
export class ConfirmMsgComponent implements OnInit {

  isAdmin :boolean = false;
  constructor(public dialogRef: MatDialogRef<ConfirmMsgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.isAdmin = localStorage.getItem("isAdmin") === "true" ? true : false;
    }
  ngOnInit(): void {
  }

  closeDialogBox(){
    this.dialogRef.close(false);
  }

  
  deleteThisExclusion(){
    this.dialogRef.close(true);
    //API call to delete
  }
}
